// @ts-ignore
import * as Config from '../Config'
import { InitializeNethoneReturn } from "./Returns"
import { NethoneOptionsStandardObject, NethoneOptionsAlternativeObject, NethoneOptionsSpecifiedObject, NethoneOptionsStrictObject } from './Option'
import { GetAttemptReference } from "../Utils";
export function InitializeNethone(NethoneOptions: NethoneOptionsStandardObject): InitializeNethoneReturn
export function InitializeNethone(NethoneOptions: NethoneOptionsAlternativeObject): InitializeNethoneReturn
export function InitializeNethone(NethoneOptions: NethoneOptionsSpecifiedObject): InitializeNethoneReturn
export function InitializeNethone(NethoneOptions: NethoneOptionsStrictObject): InitializeNethoneReturn
export function InitializeNethone(NethoneOptions: any): any {
    let ReturnObject: InitializeNethoneReturn = {} as InitializeNethoneReturn
    const IsClientSide = typeof window !== 'undefined'
    if (IsClientSide) {
        const NethoneLibrary = window['dftp']
        if (typeof NethoneLibrary !== 'undefined') {
            NethoneOptions.attemptReference = GetAttemptReference().ref
            const Message = NethoneLibrary['init'](NethoneOptions)
            ReturnObject.state = 'INITIALIZED'
            ReturnObject.log = Message
        } else {
            const NethoneScript = document.getElementById(Config.scriptId)
            NethoneScript?.addEventListener('load', () => {
                const NethoneLibrary = window['dftp']
                NethoneOptions.attemptReference = GetAttemptReference().ref
                const Message = NethoneLibrary['init'](NethoneOptions)
                ReturnObject.state = 'INITIALIZED'
                ReturnObject.log = Message
                console.log(ReturnObject)
            })
            ReturnObject.state = 'AWAITING'
            ReturnObject.log = "Call for Init is scheduled!"
        }
    } else {
        ReturnObject.state = 'ERRORED'
        ReturnObject.log = "You can't call Init function in a SSR Enviroment!"
    }
    return ReturnObject
}
